<div class="nc-video-easy-container">
    <iframe [src]="viewerUrl" width="100%" height="100%" [attr.frameBorder]="0" style="border: none;">
    </iframe>
</div>